export default {
    computed: {
        cssVars() {
            if (this.grid) {
                const { columns, ...styles } = this.grid
                return styles
            }
        }
    }
}